/* eslint-disable @typescript-eslint/no-explicit-any */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import {
  Button,
  Container,
  DropdownField,
  ExportTableButton,
} from '@/components';

import { useAuthContext } from '@/hooks';

import { getStockSummary } from '@/services/getStockSummary';
import { TableData } from '@/components/Table/types';
import { ValueItem } from '@/types/stockSummary';
import { getArmadoresList } from '@/services/getListArmadores';

import styles from './StockSummary.module.scss';
import StockSummaryTable from './StockSummaryTable';
import { columnsToExport } from './columnsToExport';

const StockSummary = () => {
  const FILE_NAME = `StockSummary-Montecon`;
  const [selectedShipOwner, setSelectedShipOwner] = useState('');
  const [parsedData, setParsedData] = useState<ValueItem[]>([]);

  const {
    data: stockSummay,
    mutate,
    isPending,
  } = useMutation({
    mutationKey: ['assignTrips'],
    mutationFn: () => getStockSummary(selectedShipOwner),
  });
  const { data: assignListDropdown } = useQuery({
    queryKey: ['armadoresListDropdown'],
    queryFn: getArmadoresList,
  });

  const { t } = useTranslation('stockSummary');

  const { userDataDecoded } = useAuthContext();

  const handleDropdownChange = (e: { value: string | null }) => {
    setSelectedShipOwner(e.value || '');
  };
  const options = userDataDecoded?.armadores?.split(';').map((val) => {
    return {
      value: val,
      name: val,
    };
  });

  const shipownerOptions = assignListDropdown?.map((val: any) => {
    return {
      value: val.codigo,
      name: val.nombre,
    };
  });

  const shipowner =
    userDataDecoded?.armadores === '*' ? shipownerOptions : options;

  useEffect(() => {
    if (stockSummay) {
      const newData = stockSummay?.map((item: any) => {
        const { ...rest } = item;

        const tipoTamano = item?.tipoTamano.match(/([A-Za-z]+)(\d{2})/);

        return {
          ...rest,
          tamano: tipoTamano[2],
          tipo: tipoTamano[1],
        };
      });
      setParsedData(newData);
    }
  }, [stockSummay]);

  return (
    <Container title={t('title')} className={styles.numberStock}>
      <div className={styles.containerSearch}>
        <div className="flex  gap-5 flex-column w-full  md:flex-row justify-content-between p-0 pb-6">
          <div className=" gap-3  flex align-items-center pl-0 ">
            <DropdownField
              className={` pl-0 md:w-26rem w-full ${styles.inputText} `}
              id="container"
              options={shipowner}
              onChange={(e) => handleDropdownChange(e)}
              label={t('container')}
              value={selectedShipOwner}
            />

            <Button
              className={`w-4rem md:w-12rem    ${styles.buttonStock}`}
              onClick={() => mutate()}
              disabled={!selectedShipOwner}
            >
              <FontAwesomeIcon icon={faMagnifyingGlass} />
              <span className="hidden md:block">{t('consult')}</span>
            </Button>
          </div>
          <div className=" flex align-items-center pl-0 justify-end">
            <ExportTableButton
              data={stockSummay as TableData}
              columnsToExport={columnsToExport}
              fileName={FILE_NAME}
            />
          </div>
        </div>
      </div>
      {parsedData && (
        <StockSummaryTable isLoading={isPending} data={parsedData} />
      )}
    </Container>
  );
};

export default StockSummary;
